module.exports = __webpack_public_path__ + "assets/img/no-results.bc1b25d1.svg";